import { useState } from "react";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const NAV = [
    { href: "#home", label: "Acasă" },
    { href: "#contact", label: "Contact" },
  ];

  return (
    <header className="sticky top-0 z-20 bg-white/80 backdrop-blur border-b">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
        {/* Left: Logo */}
        <a
          href="/"
          aria-label="Aplicație de bază"
          className="inline-flex items-center gap-2"
        >
          <img
            src="/logo.png"
            alt="Aplicație de bază"
            className="h-12 md:h-14 lg:h-16 w-auto select-none"
            draggable="false"
          />
          <img
            src="/axorcleanblack.png"
            alt="Aplicație de bază"
            className="h-12 md:h-14 lg:h-16 w-auto select-none"
            draggable="false"
          />
        </a>

        {/* Right: Desktop menu */}
        <div className="hidden md:flex items-center gap-6">
          <nav className="flex items-center gap-4 text-sm">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="hover:text-gray-700"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>

        {/* Mobile hamburger */}
        <button
          type="button"
          className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-lg border hover:bg-gray-50"
          aria-label={open ? "Închide meniul" : "Deschide meniul"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? (
            <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M6 6l12 12M6 18L18 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          ) : (
            <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M3 6h18M3 12h18M3 18h18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile dropdown */}
      {open && (
        <div className="md:hidden border-t bg-white">
          <div className="max-w-6xl mx-auto px-4 py-3">
            <nav className="grid gap-2 text-sm">
              {NAV.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="rounded-lg px-3 py-2 hover:bg-gray-50"
                >
                  {item.label}
                </a>
              ))}
            </nav>
            <div className="mt-3"></div>
          </div>
        </div>
      )}
    </header>
  );
}
